import { render, staticRenderFns } from "./CreateAttendanceAndComments.vue?vue&type=template&id=3f0360e7&scoped=true"
import script from "./CreateAttendanceAndComments.vue?vue&type=script&lang=js"
export * from "./CreateAttendanceAndComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0360e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0360e7')) {
      api.createRecord('3f0360e7', component.options)
    } else {
      api.reload('3f0360e7', component.options)
    }
    module.hot.accept("./CreateAttendanceAndComments.vue?vue&type=template&id=3f0360e7&scoped=true", function () {
      api.rerender('3f0360e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/dialog/CreateAttendanceAndComments.vue"
export default component.exports